import { Injectable } from "@angular/core";
import { GoogleTagManagerService } from "angular-google-tag-manager";

@Injectable({
  providedIn: "root",
})
export class GTMService {
  constructor(private googleTagManager: GoogleTagManagerService) {}

  pushEventTag(event: string, data: any): void {
    this.googleTagManager.pushTag({ event: event, data: data });
  }
}
